import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'
import { Icon } from '../../atoms'

export const ListItemSkeleton: React.FC<{ showIcon?: boolean; showColor?: boolean }> = ({
  showIcon = false,
  showColor = false,
}) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {showIcon && <Skeleton width={50} height={50} borderRadius={25} style={styles.iconSkeleton} />}
        {showColor && <Skeleton width={25} height={25} borderRadius={13} style={styles.colorSkeleton} />}
        <View style={styles.info}>
          <Skeleton width="60%" height={17} borderRadius={4} style={styles.nameSkeleton} />
          <Skeleton width="40%" height={15} borderRadius={4} />
        </View>
      </View>
      <Icon name="arrow" size={24} color={theme.colors.grey20} />
    </View>
  )
}

export const ListItemSkeletonList: React.FC<{
  count?: number
  showIcon?: boolean
  showColor?: boolean
}> = ({ count = 8, showIcon = false, showColor = false }) => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View>
      {Array.from({ length: count }).map((_, index) => (
        <View key={index}>
          <ListItemSkeleton showIcon={showIcon} showColor={showColor} />
          {index < count - 1 && <View style={styles.separator} />}
        </View>
      ))}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    content: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    iconSkeleton: {
      marginRight: 16,
    },
    colorSkeleton: {
      marginRight: 10,
    },
    info: {
      flex: 1,
    },
    nameSkeleton: {
      marginBottom: 4,
    },
    separator: {
      height: 0.5,
      backgroundColor: '#E5E5EA',
      marginLeft: 16,
    },
  })

